import styled from 'styled-components'

export const Button = styled.button`
    font-family: ${props => props.theme.mainFont};
    box-sizing: border-box;
    cursor: pointer;
    ${
        props => props.styled
    }
`;